import { render, staticRenderFns } from "./icon-checkbox-checked.vue?vue&type=template&id=4f5ca454&"
import script from "./icon-checkbox-checked.vue?vue&type=script&lang=js&"
export * from "./icon-checkbox-checked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports